import {StringUtils, Utils, UriHelper, ApiClientCommunication} from 'neo-common';

/**
 * @class GameClientOptions - options for game client
 */
export class GameClientOptions extends ApiClientCommunication.ApiClientOptions {
    public static get(): GameClientOptions {

        if (DEBUG) {
            var packetMode = UriHelper.getPacketsMode();
            if (packetMode) {
                return new GameClientOptions('dummy', 'dummy', false, 0);
            }
        }

        var uri = Utils.getURIQuery();
        var serverUrl = uri['serverUrl'];

        var token = UriHelper.getHashGroupValue('token', '');

        if (StringUtils.isNullOrEmpty(token)) {
            throw new Error(`Could not found #token hash in url, which is required!`);
        }

        return new GameClientOptions(serverUrl, token, false, 0);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/GameClientOptions.ts
 **/